import type { ComponentType, DataType } from '@vgtv/api-client/lib/component';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import { createReducer } from '@reduxjs/toolkit';

import type { Vendor } from '../../types';

import { cleanupSharedState, fetchSearchResults } from './actions';

export type SearchComponent = {
  id: string;
  provider?: Vendor;
  header: string;
  type: ComponentType.SLIDER | ComponentType.LIST;
  options: {
    skipMetadata?: boolean;
    useLargeThumbnails?: boolean;
    useVerticalPosters?: boolean;
  };
  analytics?: {
    algolia?: {
      indexName: string;
      queryID: string;
    };
  };
  data:
    | {
        type: DataType.CATEGORIES;
        preset: SvpCategoryAdditional[];
      }
    | {
        type: DataType.ASSETS;
        preset: SvpAssetAdditional[];
      };
};

export type SearchState = {
  components?: SearchComponent[];
};

const initialState: SearchState = {};

export const searchReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(fetchSearchResults.fulfilled, (state, action) => {
      state.components = action.payload.components;
    })
    .addCase(cleanupSharedState, (state) => {
      state.components = undefined;
    })
);
